export async function createPickupAddressUseCase(data, pickupAddressRepository) {
    const result = await pickupAddressRepository.create(data);

    return result;
}